import { fetchData } from "@/lib/api/fetchData";
import { formatActions } from "@/lib/formatter/actions";

export const getActionsForTable = async () => {
  try {
    const res = await fetchData("/rules/actions");

    return formatActions(res.data);
  } catch (error) {
    console.error(error);
    throw new Error("Failed to load actions");
  }
};

export const getActionById = async (id) => {
  try {
    const res = await fetchData(`/rules/actions/${id}`);

    return res.data;
  } catch (error) {
    console.error(error);
    throw new Error("Failed to load action");
  }
};

export const getActionTypesForSelect = async () => {
  try {
    const res = await fetchData("/rules/actiontypes");

    return res.data.map((RuleActionType) => ({
      value: RuleActionType["@id"],
      label: RuleActionType.value,
    }));
  } catch (error) {
    console.error(error);
    throw new Error("Failed to load action types");
  }
};
